/** @file Whether a delete command would accept a target; menus, Delete keys, Inspector and dialog share it. */
import { docIndex } from '@pose2d/format/doc/docIndex';
import { ENTITY_KINDS } from '@pose2d/format/doc/entityKinds';
import type { Doc, EntityKind, Id } from '@pose2d/format/types';

/** False for an id that is gone, the root bone, a generated socket bone and an image something still uses (the commands refuse those). */
export function deletable(doc: Doc, target: { kind: EntityKind; id: Id }): boolean {
  const { kind, id } = target;
  if (!Object.hasOwn(doc[ENTITY_KINDS[kind]], id)) return false;
  if (kind === 'bone') return doc.bones[id]?.parent !== null && doc.bones[id]?.kind === undefined;
  if (kind === 'image') return (docIndex(doc).referencedBy.get(id)?.size ?? 0) === 0;
  return true;
}
